import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-spinner-container" role="status" aria-live="polite">
      <div className="loading-spinner">
        <div className="spinner" aria-hidden="true"></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner; 